module.exports = __webpack_public_path__ + "static/media/messages2.28ef867d.png";